export const basic = {
  dmBlack: '#000000',
  dmBackgroundDarkest: '#0d0d0f',
  dmSecondaryBackground: '#1f2025',
  dmWhite: '#ffffff',
  dmDarkestPurple: '#1b1631',
  dmSelectionHover: '#282536',
  dmCardsStroke: '#413e60',
  dmCardsHover: '#1d1d1d',
  dmYellowSearchResult: '#fff599',
} as const;

export const grey = {
  dmDarkGrey: '#333333',
  dmMediumGrey: '#555555',
  dmLightGreyDisabled: '#999999',
  dmExtraLightGrey: '#cccccc',
} as const;

export const purple = {
  dmExtraDarkPurple: '#201256',
  dmPurpleHeader: '#3f2b95',
  dmDarkPurple: '#3f307d',
  dmMediumDarkPurple: '#5843af',
  dmMediumPurple: '#6f5ac2',
  dmLightPurple: '#a692f8',
  dmExtraLightPurple: '#d3c9fc',
} as const;

export const status = {
  dmRedWarning: '#f52c11',
  dmOrangeWarning: '#fe9b28',
  dmGreenGood: '#53b964',
  dmBlueInfo: '#189eff',
  dmRedWarningBkg: '#4a2221',
  dmOrangeWarningBkg: '#4c3926',
  dmGreenGoodBkg: '#293f32',
  dmBlueInfoBkg: '#1e3951',
  dmLightGreyDisabledBkg: '#37383c',
} as const;

export const actions = {
  dmBdgBlueAddReviewers: '#497cff',
  dmBdgCyanAddComment: '#33d8fc',
  dmBdgLtGreenAddLabel: '#8ffd85',
  dmBdgLtGreenAddLabels: '#60BF80',
  dmBdgGreenApprove: '#2eba5d',
  dmBdgYellowRequireReviewers: '#ffc34e',
  dmBdgOrangeSetRequiredApproval: '#fa8c3c',
  dmBdgMagentaMerge: '#b132ff',
  dmBdgRedRequestChanges: '#ff6a6a',
  dmBdgDrkRedClose: '#c5005f',
  dmBdgGreyMore: '#ffffff',

  // Additional colors not assigned to a specific action
  dmBdgPink: '#ec8dee',
  dmBdgOliveGreen: '#6a711f',
  dmBdgLtYellow: '#fcff77',
  dmBdgLtOrange: '#fcab70',
  dmBdgDrkBlue: '#4b3cf0',
} as const;

export const colorPalette = {
  ...basic,
  ...grey,
  ...purple,
  ...status,
  ...actions,
};
